import React from 'react';
import { useNavigate } from '../../navigation';
import { logEvent, getAnalytics } from 'firebase/analytics';

type Props = {
  cta?: string;
  applyFilter?: boolean;
};

const TableTabBanner: React.FC<Props> = ({
  cta = 'TableTab',
  applyFilter = true,
}) => {
  const analytics = getAnalytics();

  const navigate = useNavigate();

  return (
    <>
      {
        <div className="w-full mb-10 pb-16">
          <a
            className="text-on-surface/60"
            href={`${
              /(.*)(snapntap\.com)/.test(window.location.hostname)
                ? 'https://snapntap.com'
                : 'https://snapntap.com'
            }?ref=guest_app_bottom_banner_cta`}
            target="_blank"
            onClick={() => {
              logEvent(analytics, 'powered_by_clicked');
            }}
          >
            <div
              className={`${
                applyFilter ? 'filter' : 'text-primary-600'
              } flex flex-row p-1 items-center justify-center rounded-md`}
            >
              {/* <div className=" font-bold text-sm text-center">Powered by</div> */}
              <div className={'w-60 md:w-60'}>
                <img
                  className={'rounded-md'}
                  src={
                    'https://imagedelivery.net/ItAyqz9sINmb7Hat_ZbSQA/59befebb-f0b8-4343-adb5-55faf9722d00/hq'
                  }
                ></img>
              </div>
            </div>
          </a>
        </div>
      }
    </>
  );
};

export default TableTabBanner;
